import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { RefreshProvider } from "@/context/RefreshContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import AcceptInvitation from "@/pages/AcceptInvitation";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DeviceRouter from "@/components/DeviceRouter";
import Admin from "@/pages/Admin";
import MapPage from "@/pages/MapPage";
import RawData from "@/pages/RawData";

import AlarmSettings from "@/pages/AlarmSettings";
import TVDashboard from "@/pages/TVDashboard";
import { Loader2 } from "lucide-react";

function Protected({ children, roles, bare = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="flex min-h-screen items-center justify-center bg-background"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return bare ? children : <Layout>{children}</Layout>;
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex min-h-screen items-center justify-center bg-background"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <RefreshProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/uitnodiging" element={<AcceptInvitation />} />
              <Route path="/login" element={<LoginRoute />} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/tv" element={<Protected bare><TVDashboard /></Protected>} />
              <Route path="/kaart" element={<Protected><MapPage /></Protected>} />
              <Route path="/devices/:id" element={<Protected><DeviceRouter /></Protected>} />
              <Route path="/alarms" element={<Protected><AlarmSettings /></Protected>} />
              <Route path="/devices/:id/installation" element={<Protected roles={["admin"]}><DeviceRouter installation /></Protected>} />
              <Route path="/admin" element={<Protected roles={["admin"]}><Admin /></Protected>} />
              <Route path="/raw" element={<Protected roles={["manager", "admin"]}><RawData /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
          </RefreshProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
